<!-- <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
  <div
    *ngFor="let c of cards"
    class="rounded-xl border border-card-contrast bg-card p-5 shadow-sm flex items-center gap-4"
  >
    <div
      class="h-10 w-10 flex items-center justify-center rounded-lg"
      [ngClass]="{
        'bg-primary-100 text-primary-700 dark:bg-primary-200/10 dark:text-primary-800': c.accent === 'primary',
        'bg-secondary-100 text-secondary-700 dark:bg-secondary-200/10 dark:text-secondary-800': c.accent === 'success',
        'bg-orange-100 text-orange-700 dark:bg-orange-200/10 dark:text-orange-300': c.accent === 'warn'
      }"
    >
      <i class="pi" [ngClass]="c.icon"></i>
    </div>
    <div class="flex-1">
      <div class="text-3xl font-semibold text-foreground">{{ c.value }}</div>
      <div class="text-foreground-secondary text-sm">{{ c.title }}</div>
    </div>
  </div>
</div> -->










<!-- this is tailwind  -->
<!-- <div class="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-4 p-5 bg-[#f7f7f7] rounded-xl">
  <div 
    class="cursor-pointer flex flex-col gap-1.5 rounded-2xl bg-white dark:bg-gray-800 p-4 shadow-[0_3px_6px_rgba(0,0,0,0.05),0_12px_32px_rgba(0,0,0,0.08)] transition hover:-translate-y-1 hover:shadow-[0_4px_8px_rgba(0,0,0,0.06),0_14px_34px_rgba(0,0,0,0.12)]"
    *ngFor="let item of cards"
    [ngClass]="item.accent"
  >

    <div 
      class="flex h-8 w-8 items-center justify-center rounded-xl  dark:bg-gray-700
 text-[20px]"
    >
      <i [ngClass]="'pi ' + item.icon"></i>
    </div>

    <div class="text-[32px] font-semibold md:text-[32px] text-[26px]">
      {{ item.value }}
    </div>

    <div class="text-[16px] font-medium">
      {{ item.title }}
    </div>

  </div>
</div>


 -->



 <div class="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-4 p-5 bg-gray-100 rounded-xl dark:bg-[#1B3C53]">
  <div 
    class="cursor-pointer flex flex-col gap-1.5 rounded-2xl bg-white dark:bg-gray-800 p-4 shadow-[0_3px_6px_rgba(0,0,0,0.05),0_12px_32px_rgba(0,0,0,0.08)] transition hover:-translate-y-1 hover:shadow-[0_4px_8px_rgba(0,0,0,0.06),0_14px_34px_rgba(0,0,0,0.12)]"
    *ngFor="let item of cards"
    [ngClass]="item.accent"
  >
    <!-- Title and Icon in the same row -->
    <div class="flex items-center justify-between">
      <div class="text-[15px] font-medium text-gray-700 dark:text-white">
        {{ item.title }}
      </div>
      <!-- Icon on the extreme right of the same line as the title -->
      <div class="flex h-8 w-8 items-center justify-center rounded-xl dark:bg-gray-700 text-[20px]">
        <i [ngClass]="'pi ' + item.icon"></i>
      </div>
    </div>

    <!-- Value below the Title and Icon -->
    <div class="font-semibold md:text-[32px] text-[26px] mt-2">
      {{ item.value }}
    </div>
  </div>
</div>
